import { Link } from "react-router-dom";
import heroImage from "../../assets/criminal-law-hero.webp";
import sectionImg from "../../assets/lady-justice-parallax.webp";
function Criminal() {
  return (
    <>
      {/* ================= HERO ================= */}
      <section className="relative h-[80vh] flex items-center justify-center pt-24">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        ></div>

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* CONTENT */}
        <div className="relative z-10 text-center text-white px-6 max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-dancing-script">
            Criminal Defence
          </h1>

          <p className="mt-4 text-lg text-gray-200">
          
          </p>
        </div>

      </section>

      {/* ================= CONTENT ================= */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">

          <div className="space-y-8">

  {/* HERO CARD WITH BACKGROUND IMAGE */}
  <div
    className="relative rounded-[28px] overflow-hidden"
    style={{
      backgroundImage: `url(${sectionImg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >

    {/* DARK OVERLAY */}
    <div className="absolute inset-0 bg-black/70"></div>

    {/* CONTENT */}
    <div className="relative z-10 p-10 md:p-14 text-white">

      <p className="text-yellow-400 uppercase tracking-[5px] text-sm font-semibold mb-5">
        Criminal Defense (Select Matters)
      </p>

      <h3 className="text-3xl md:text-4xl font-bold leading-tight mb-6">
        Presumption of Innocence, <br /> Vigorously Defended.
      </h3>

      <p className="text-gray-200 text-lg leading-relaxed max-w-3xl">
        At <strong>GATI & CO. ADVOCATES</strong>, we understand that criminal
        proceedings can have life-altering consequences. Our approach combines
        strategic defense, procedural precision, and unwavering protection of
        constitutional rights to ensure every client receives fair representation
        and a strong legal defense at every stage of the criminal justice process.
      </p>

    </div>

  </div>

  {/* SERVICES GRID */}
  <div className="grid md:grid-cols-3 gap-6">

    {/* CARD 1 */}
    <div className="group bg-white border border-gray-200 hover:border-yellow-500 rounded-[24px] p-8 transition-all duration-500 hover:shadow-2xl hover:-translate-y-1">

      <div className="w-12 h-12 rounded-full bg-yellow-500/10 flex items-center justify-center mb-6 group-hover:bg-yellow-500 transition-all duration-300">
        <div className="w-3 h-3 rounded-full bg-yellow-500 group-hover:bg-white"></div>
      </div>

      <h4 className="text-2xl font-bold text-[#0B1C39] mb-4">
        Bail & Bond Applications
      </h4>

      <p className="text-gray-600 leading-relaxed">
        We provide urgent court representation to secure fair bail and bond terms,
        ensuring our clients regain their liberty as proceedings continue.
      </p>

    </div>

    {/* CARD 2 */}
    <div className="group bg-white border border-gray-200 hover:border-yellow-500 rounded-[24px] p-8 transition-all duration-500 hover:shadow-2xl hover:-translate-y-1">

      <div className="w-12 h-12 rounded-full bg-yellow-500/10 flex items-center justify-center mb-6 group-hover:bg-yellow-500 transition-all duration-300">
        <div className="w-3 h-3 rounded-full bg-yellow-500 group-hover:bg-white"></div>
      </div>

      <h4 className="text-2xl font-bold text-[#0B1C39] mb-4">
        Trial Defense
      </h4>

      <p className="text-gray-600 leading-relaxed">
        Our firm handles defense for select criminal matters including theft,
        assault, fraud, and breach of peace with strategic preparation and
        vigorous courtroom advocacy.
      </p>

    </div>

    {/* CARD 3 */}
    <div className="group bg-white border border-gray-200 hover:border-yellow-500 rounded-[24px] p-8 transition-all duration-500 hover:shadow-2xl hover:-translate-y-1">

      <div className="w-12 h-12 rounded-full bg-yellow-500/10 flex items-center justify-center mb-6 group-hover:bg-yellow-500 transition-all duration-300">
        <div className="w-3 h-3 rounded-full bg-yellow-500 group-hover:bg-white"></div>
      </div>

      <h4 className="text-2xl font-bold text-[#0B1C39] mb-4">
        Plea Bargaining
      </h4>

      <p className="text-gray-600 leading-relaxed">
        We negotiate reduced charges and favorable resolutions where appropriate,
        always prioritizing our clients’ rights, dignity, and long-term interests.
      </p>

    </div>

  </div>

</div>
        </div>
      </section>

      {/* ================= NAV BUTTONS ================= */}
      <section className="py-12 px-6 bg-gray-100 border-t border-gray-200">
        <div className="max-w-7xl mx-auto flex justify-between items-center">

          {/* LEFT BUTTON */}
          <Link
            to="/services"
            className="px-6 py-3 border-2 border-[#0B3D91] text-[#0B3D91] bg-white rounded-lg font-semibold hover:bg-[#0B3D91] hover:text-white transition hover:-translate-x-1"
          >
            ← Back to practice areas
          </Link>

          {/* RIGHT BUTTON */}
          <Link
            to="/services/commercial"
            className="px-6 py-3 bg-[#0B3D91] text-white rounded-lg font-semibold hover:bg-blue-800 transition hover:translate-x-1"
          >
            Next Area →
          </Link>

        </div>
      </section>
    </>
  );
}

export default Criminal;